import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Shell from "../components/Shell";
import { api, subjectMeta } from "../lib/api";
import { CheckCircle, XCircle, MinusCircle, FileText, ListChecks } from "@phosphor-icons/react";

const dateLabel = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("tr-TR", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export default function History() {
  const [subs, setSubs] = useState([]);
  const [tests, setTests] = useState([]);
  const [tab, setTab] = useState("submissions");

  useEffect(() => {
    api.get("/submissions").then((r) => setSubs(r.data)).catch(() => {});
    api.get("/tests").then((r) => setTests(r.data)).catch(() => {});
  }, []);

  return (
    <Shell title="Geçmişin">
      <h1 className="font-outfit font-extrabold text-3xl text-brand-ink mb-4">Geçmiş</h1>

      <div className="flex gap-2 p-1 bg-brand-paperAlt rounded-full mb-5" data-testid="history-tabs">
        <button
          data-testid="history-tab-submissions"
          onClick={() => setTab("submissions")}
          className={`flex-1 py-2 rounded-full font-outfit font-semibold text-sm ${tab === "submissions" ? "bg-white text-brand-ink shadow" : "text-brand-ink2"}`}
        >Ödevler ({subs.length})</button>
        <button
          data-testid="history-tab-tests"
          onClick={() => setTab("tests")}
          className={`flex-1 py-2 rounded-full font-outfit font-semibold text-sm ${tab === "tests" ? "bg-white text-brand-ink shadow" : "text-brand-ink2"}`}
        >Testler ({tests.length})</button>
      </div>

      {tab === "submissions" && (
        <div className="flex flex-col gap-3" data-testid="submissions-list">
          {subs.length === 0 && (
            <div className="text-center text-brand-ink2 font-nunito py-10">Henüz ödev yüklemedin. <FileText size={20} className="inline" /></div>
          )}
          {subs.map((s) => {
            const sm = subjectMeta(s.subject);
            return (
              <Link
                key={s.id}
                to={`/app/result/${s.id}`}
                data-testid={`history-submission-${s.id}`}
                className="bg-white rounded-2xl shadow-sm p-4 flex items-center gap-3 active:scale-[0.99] transition-transform"
              >
                <div className="w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0" style={{ background: sm.bg }}>
                  <FileText size={22} weight="duotone" color={sm.color} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-outfit font-bold text-brand-ink">{sm.name}</div>
                  <div className="text-xs font-nunito text-brand-ink2">{dateLabel(s.created_at)}</div>
                </div>
                <div className="flex items-center gap-2 font-nunito font-bold text-sm">
                  <span className="text-good flex items-center gap-1"><CheckCircle size={16} weight="fill" /> {s.correct}</span>
                  <span className="text-bad flex items-center gap-1"><XCircle size={16} weight="fill" /> {s.incorrect}</span>
                  <span className="text-blank flex items-center gap-1"><MinusCircle size={16} weight="fill" /> {s.blank}</span>
                </div>
              </Link>
            );
          })}
        </div>
      )}

      {tab === "tests" && (
        <div className="flex flex-col gap-3" data-testid="tests-list">
          {tests.length === 0 && (
            <div className="text-center text-brand-ink2 font-nunito py-10">Henüz test çözmedin.</div>
          )}
          {tests.map((t) => (
            <div key={t.id} className="bg-white rounded-2xl shadow-sm p-4 flex items-center gap-3" data-testid={`history-test-${t.id}`}>
              <div className="w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0 bg-brand-primary/20">
                <ListChecks size={22} weight="duotone" color="#FFA200" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-outfit font-bold text-brand-ink">{t.subject ? subjectMeta(t.subject).name : "Genel test"}</div>
                <div className="text-xs font-nunito text-brand-ink2">{dateLabel(t.created_at)}</div>
              </div>
              <div className="font-outfit font-extrabold text-xl text-brand-ink">
                {t.score != null ? `${t.score}/10` : "—"}
              </div>
            </div>
          ))}
        </div>
      )}
    </Shell>
  );
}
